import { Injectable } from '@angular/core';
import { CustomerSupportMessage } from '../interfaces/customer-support-message';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs';

@Injectable({
     providedIn: 'root'
})
export class CustomerSupportService {

     constructor(private http: HttpClient) { }

     sendCustomerSupportMessage(message: CustomerSupportMessage): boolean | any {
  
          if (message) {
              const url: string = `${environment.APP_API_URL}/api/v1/CustomerSupport/sendCustomerSupportMessage`;
              return this.http.post(url, message)
                   .pipe(
                        map((response: any) =>
                             response as boolean),
                        catchError(error => {
                             console.error(error);
                             return ['false'];
                        })
                   );
             
          } else {
              return false;
          }
      }
}
